/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaWhatsapp,
  FaEnvelope,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import emailjs from "@emailjs/browser";
function ContactPage() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* WHATSAPP */
const handleWhatsAppSubmit = async (e) => {

  e.preventDefault();

  /* WHATSAPP */
  const phoneNumber = "916394941232";

  const text = `
New Inquiry - Arsons Beauty Zone

👤 Name: ${formData.name}

📧 Email: ${formData.email}

📝 Message: ${formData.message}
`;

  const whatsappURL =
    `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;

  window.open(whatsappURL, "_blank");

  /* EMAIL SEND */
  // try {

  //   await emailjs.send(
  //     "YOUR_SERVICE_ID",
  //     "YOUR_TEMPLATE_ID",
  //     {
  //       from_name: formData.name,
  //       from_email: formData.email,
  //       message: formData.message,
  //     },
  //     "YOUR_PUBLIC_KEY"
  //   );

  //   console.log("Email Sent");

  // } catch (error) {

  //   console.log(error);

  // }

};

  /* EMAIL */
  const handleEmailSubmit = (e) => {
    e.preventDefault();

    const subject =
      "New Inquiry - Arsons Beauty Zone";

    const body = `
Name: ${formData.name}

Email: ${formData.email}

Message:
${formData.message}
`;

    const mailtoLink =
      `mailto:arsonsbeautyzone@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <>
<Helmet>

  <title>
    Best Beauty Parlour & Bridal Makeup Artist
    in Prayagraj | Arson's Beauty Zone
  </title>

  <meta
    name="description"
    content="
    Contact Arson's Beauty Zone for bridal
    makeup, beauty parlour services, hair styling,
    skincare and luxury salon appointments
    in Prayagraj Jhusi.
    "
  />

</Helmet>
      <style>
        {`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Manrope:wght@300;400;500;600;700&display=swap');

        :root{
          --primary:#d8b06e;
          --secondary:#f7d79b;
          --gold:#d8b06e;
          --dark:#050505;
          --light:#0b0b0b;
          --text:#cfcfcf;
        }

        body{
          background:var(--light);
          overflow-x:hidden;
          font-family:'Manrope',sans-serif;
          color:white;
        }

        .luxury-heading{
          font-family:'Cormorant Garamond',serif;
        }

        .section-tag{
          color:var(--primary);
          letter-spacing:4px;
          font-size:14px;
          font-weight:700;
        }

        .glass-card{

          background:
            linear-gradient(
              to bottom,
              rgba(18,18,18,0.94),
              rgba(8,8,8,0.94)
            );

          backdrop-filter:blur(22px);

          border:
            1px solid rgba(216,176,110,0.12);
        }

        .premium-input{

          background:
            rgba(255,255,255,0.04) !important;

          border:
            1px solid rgba(216,176,110,0.12) !important;

          padding:20px !important;

          border-radius:20px !important;

          transition:all .4s ease !important;

          box-shadow:none !important;

          color:white !important;
        }

        .premium-input::placeholder{
          color:rgba(255,255,255,0.4);
        }

        .premium-input:focus{

          border:
            1px solid #d8b06e !important;

          box-shadow:
            0 0 0 4px rgba(216,176,110,0.12) !important;
        }

        .premium-btn{
          position:relative;
          overflow:hidden;
          transition:all .45s ease;
        }

        .premium-btn:hover{

          transform:
            translateY(-5px);

          box-shadow:
            0 20px 45px rgba(216,176,110,0.22);
        }

        .premium-btn::before{
          content:'';
          position:absolute;
          top:0;
          left:-120%;
          width:100%;
          height:100%;
          background:rgba(255,255,255,0.18);
          transform:skewX(-20deg);
          transition:.7s;
        }

        .premium-btn:hover::before{
          left:120%;
        }

        .contact-card{
          transition:all .5s ease;
        }

        .contact-card:hover{

          transform:
            translateY(-10px)
            scale(1.02);

          border:
            1px solid rgba(216,176,110,0.24);

          box-shadow:
            0 35px 80px rgba(0,0,0,0.55);
        }

        iframe{
          filter:
            grayscale(15%)
            contrast(1.05);
        }

       @media(max-width:768px){

  .hero-heading{
    font-size:60px !important;
  }

  /* LEFT CONTACT CARDS */
  .contact-card{
    padding:22px !important;
    border-radius:22px !important;
  }

  .contact-card h5{
    font-size:26px !important;
  }

  .contact-card p{
    font-size:14px !important;
    line-height:1.8 !important;
    word-break:break-word;
  }

  /* FORM BOX */
  .form-wrapper{
    padding:28px !important;
    border-radius:28px !important;
  }

  .form-wrapper h2{
    font-size:42px !important;
  }

  .premium-input{
    padding:16px !important;
    font-size:14px !important;
  }

  iframe{
    height:240px !important;
  }
     .email-card-wrapper{
    flex-direction:row !important;
    align-items:center !important;
    justify-content:space-between !important;
  }

  .email-card-wrapper a{
    padding:10px 16px !important;
    font-size:13px !important;
  }
}

      `}
      </style>

      {/* CONTACT */}
      <section
        style={{
          padding: "140px 0",
          background:
            "linear-gradient(to bottom,#050505,#111111)",
          position: "relative",
          overflow: "hidden",
        }}
      >

        {/* GOLD GLOW */}
        <div
          style={{
            position: "absolute",
            width: "420px",
            height: "420px",
            background: "#d8b06e",
            filter: "blur(170px)",
            borderRadius: "50%",
            top: "8%",
            left: "-120px",
            opacity: 0.16,
          }}
        />

        <div className="container position-relative">

          <div className="row align-items-center g-5">

            {/* LEFT */}
            <div className="col-lg-5">

              <p
                className="section-tag"
                style={{
                  textDecoration: "underline",
                  textDecorationColor: "#d8b06e",
                }}
              >
                GET IN TOUCH
              </p>

              <h2
                className="luxury-heading"
                style={{
                  fontSize: "clamp(60px,6vw,90px)",
                  lineHeight: "0.92",
                  color: "#fff",
                }}
              >
                Let’s Make <br />
                You Shine
              </h2>

              <p
                style={{
                  marginTop: "30px",
                  lineHeight: "2",
                  color:
                    "rgba(255,255,255,0.72)",
                  fontSize: "17px",
                }}
              >
                Contact us for premium bridal makeup,
                luxury salon care, skincare consultations,
                wedding beauty transformations, and
                personalized bridal styling.
              </p>

              <div className="mt-5 d-flex flex-column gap-4">

                {/* PHONE */}
              <div
  className="glass-card contact-card"
  style={{
    padding: "32px",
    borderRadius: "30px",
  }}
>
  <div
    className="d-flex justify-content-between align-items-center flex-wrap gap-3"
  >

    <div>
      <h5
        className="luxury-heading"
        style={{
          fontSize: "36px",
          color: "#fff",
        }}
      >
        📞 Phone
      </h5>

      <p
        style={{
          color: "rgba(255,255,255,0.72)",
          marginBottom: 0,
          letterSpacing: "1px",
        }}
      >
        +91 6394941232
      </p>
    </div>

    <a
      href="tel:+916394941232"
      style={{
        background:
          "linear-gradient(to right,#16a34a,#22c55e)",
        color: "#fff",
        padding: "12px 22px",
        borderRadius: "50px",
        textDecoration: "none",
        fontWeight: "700",
        whiteSpace: "nowrap",
        boxShadow:
          "0 10px 25px rgba(34,197,94,0.25)",
      }}
    >
      Call Now
    </a>

  </div>
</div>

                {/* EMAIL */}
               {/* EMAIL */}
<div
  className="glass-card contact-card"
  style={{
    padding: "32px",
    borderRadius: "30px",
  }}
>
  <div
   className="d-flex align-items-center justify-content-between gap-3 email-card-wrapper"
  >

    <div>
      <h5
        className="luxury-heading"
        style={{
          fontSize: "36px",
          color: "#fff",
        }}
      >
        📧 Email
      </h5>

      <p
        style={{
          color: "rgba(255,255,255,0.72)",
          marginBottom: 0,
          letterSpacing: "1px",
        }}
      >
        arsonsbeautyzone@gmail.com
      </p>
    </div>

    <a
      href="mailto:arsonsbeautyzone@gmail.com"
      style={{
        background:
          "linear-gradient(to right,#d8b06e,#f7d79b)",

        color: "#000",

        padding: "12px 22px",

        borderRadius: "50px",

        textDecoration: "none",

        fontWeight: "700",

        whiteSpace: "nowrap",

        boxShadow:
          "0 10px 25px rgba(216,176,110,0.25)",
      }}
    >
      Send Email
    </a>

  </div>
</div>

                {/* ADDRESS */}
                <div
                  className="glass-card contact-card"
                  style={{
                    padding: "32px",
                    borderRadius: "30px",
                  }}
                >
                  <h5
                    className="luxury-heading"
                    style={{
                      fontSize: "36px",
                      color: "#fff",
                    }}
                  >
                    📍 Studio Address
                  </h5>

                  <p
                    style={{
                      color:
                        "rgba(255,255,255,0.72)",
                      marginBottom: 0,
                    }}
                  >
                   Branch 1- 1/220 MIG AVAS VIKAS COLONY JHUSI PRAYAGRAJ
                  </p>
                  <br></br>
                   <p
                    style={{
                      color:
                        "rgba(255,255,255,0.72)",
                      marginBottom: 0,
                    }}
                  >
                   Branch 2- Chhatnag road(near patanjali chikatsalaya), Jhusi, Prayagraj,
                Uttar Pradesh
                  </p>
                </div>

              </div>
            </div>

            {/* RIGHT */}
            <div className="col-lg-7">

              <div
                className="glass-card form-wrapper"
                style={{
                  padding: "55px",
                  borderRadius: "40px",
                  boxShadow:
                    "0 35px 90px rgba(0,0,0,0.45)",
                }}
              >

                <h2
                  className="luxury-heading"
                  style={{
                    fontSize:
                      "clamp(50px,5vw,75px)",
                    color: "#fff",
                    marginBottom: "10px",
                  }}
                >
                  Send Inquiry
                </h2>

                <p
                  style={{
                    color:
                      "rgba(255,255,255,0.72)",
                    marginBottom: "35px",
                  }}
                >
                  We would love to hear about your
                  dream bridal look.
                </p>

                <form>

                  {/* NAME */}
                  <div className="mb-4">

                    <label
                      className="mb-2"
                      style={{
                        fontWeight: "600",
                        color: "#fff",
                      }}
                    >
                      Full Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control premium-input"
                      placeholder="Enter your full name"
                    />

                  </div>

                  {/* EMAIL */}
                  <div className="mb-4">

                    <label
                      className="mb-2"
                      style={{
                        fontWeight: "600",
                        color: "#fff",
                      }}
                    >
                      Email Address
                    </label>

                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control premium-input"
                      placeholder="Enter your email address"
                    />

                  </div>

                  {/* MESSAGE */}
                  <div className="mb-4">

                    <label
                      className="mb-2"
                      style={{
                        fontWeight: "600",
                        color: "#fff",
                      }}
                    >
                      Your Message
                    </label>

                    <textarea
                      rows="5"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-control premium-input"
                      placeholder="Write your bridal inquiry..."
                    ></textarea>

                  </div>

                  {/* BUTTONS */}
                  <div className="d-flex flex-column flex-md-row gap-3">

                 

                    {/* WHATSAPP */}
                    <button
                      onClick={handleWhatsAppSubmit}
                      className="premium-btn"
                      style={{
                        background:
                          "linear-gradient(to right,#1ea952,#25D366)",

                        color: "white",

                        border: "none",

                        padding: "18px",

                        borderRadius: "60px",

                        fontWeight: "700",

                        flex: 1,
                      }}
                    >
                      <>
                        <FaWhatsapp
                          style={{
                            marginRight: "10px",
                            marginTop: "-2px",
                            fontSize: "20px",
                          }}
                        />

                        Submit on WhatsApp
                      </>
                    </button>

                  </div>

                </form>

                {/* MAP */}
                <div
                  style={{
                    marginTop: "45px",
                    borderRadius: "30px",
                    overflow: "hidden",
                    boxShadow:
                      "0 25px 60px rgba(0,0,0,0.45)",
                  }}
                >

                  <iframe
                    title="map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.3819033999503!2d81.91240218801804!3d25.425492593084222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39854b226f9fcd0f%3A0x85f7c1655b607cc7!2sArson's%20Beauty%20Zone%20-%20Womaniya%20Beauty%20Salon!5e0!3m2!1sen!2sin!4v1778347466060!5m2!1sen!2sin"
                    width="100%"
                    height="320"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>

                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;